import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import i18nService from "@/core/services/i18n.service.js";

// This option suppresses all Vuetify logs and warnings in production
Vuetify.config.silent = process.env.NODE_ENV === "production" ? true : false;

Vue.use(Vuetify);

// Translation provided by Vuetify (javascript)
import fa from "vuetify/es5/locale/fa";
import en from "vuetify/es5/locale/en";

export default new Vuetify({
  rtl: i18nService.isActiveLanguageDirectionRtl() ? true : false,
  lang: {
    locales: { en, fa },
    current: i18nService.getActiveLanguageLang()
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      // light: {
      //   primary: "#5867dd",
      //   secondary: "#e8ecfa",
      //   accent: "#5d78ff",
      //   error: "#fd397a",
      //   info: "#5578eb",
      //   success: "#0abb87",
      //   warning: "#ffb822"
      // }
    }
  }
});
